export class Toast {
    static show(message, type = 'success', duration = 3000) {
        // Remove existing toast
        const existing = document.getElementById('toast-notification');
        if (existing) existing.remove();

        const toast = document.createElement('div');
        toast.id = 'toast-notification';

        let bgClass = 'bg-gray-900';
        let icon = 'check_circle';

        if (type === 'error') {
            bgClass = 'bg-red-500';
            icon = 'error';
        } else if (type === 'info') {
            bgClass = 'bg-blue-600';
            icon = 'info';
        }

        toast.className = `fixed top-6 left-1/2 -translate-x-1/2 z-[3000] flex items-center gap-3 px-6 py-3 rounded-full shadow-2xl ${bgClass} text-white pointer-events-none opacity-0 translate-y-[-20px] transition-all duration-300`;
        toast.innerHTML = `
            <span class="material-symbols-outlined text-lg">${icon}</span>
            <span class="text-sm font-bold">${message}</span>
        `;

        document.body.appendChild(toast);

        // Animate In
        requestAnimationFrame(() => {
            toast.classList.remove('opacity-0', 'translate-y-[-20px]');
        });

        // Auto Remove
        setTimeout(() => {
            toast.classList.add('opacity-0', 'translate-y-[-20px]');
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }
}
